import React, { Component } from 'react';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { withRouter, Link } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Panel } from 'primereact/panel';
import { Column } from 'primereact/column';
import { sortUrl, parse, toSortOrder } from '../../../../../../utils/UrlUtil';
import { withAccount } from '../../../../../../components/AccountContext';

const messages = defineMessages({
  name: { id: 'attrs.name', defaultMessage: 'name' },
  created: { id: 'attrs.created', defaultMessage: 'Created' },
  updated: { id: 'attrs.updated', defaultMessage: 'Updated' },
});

const nameTemplate = (rowData, {
  currentAccount, keyField, displayField, surveyProjectId,
}) => {
  const detailUrl = `/accounts/${currentAccount}/survey-projects/${surveyProjectId}/imports/${rowData[keyField]}`;
  return (
    <Link to={detailUrl} className="app-link">
      {rowData[displayField]}
    </Link>
  );
};

const timeFieldTemplate = (rowData, { formatDate, field }) => {
  const updated = formatDate(moment(rowData[field]), {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });
  return updated;
};

const statusTemplate = (rowData) => {
  switch (rowData.status) {
    case 'VALID_IMPORT': {
      return (
        <FormattedMessage id="file_import.valid" defaultMessage="Valid">
          {text => <span className="filter filter--info is-active">{text}</span>}
        </FormattedMessage>
      );
    }
    case 'FAILED_IMPORT': {
      return (
        <FormattedMessage id="ile_import.failed" defaultMessage="Failed">
          {text => <span className="filter filter--error is-active">{text}</span>}
        </FormattedMessage>
      );
    }
    case 'ACTIVATED': {
      return (
        <FormattedMessage id="file_import.activated" defaultMessage="Activated">
          {text => <span className="filter filter--success is-active ">{text}</span>}
        </FormattedMessage>
      );
    }
    default: {
      return null;
    }
  }
};

class ImportedFileList extends Component {
  constructor(props) {
    super(props);
    this.onSortChange = this.onSortChange.bind(this);
  }

  onSortChange(event) {
    const { location, history } = this.props;
    sortUrl(event, location, history);
  }

  render() {
    const {
      files,
      intl: { formatMessage, formatDate },
      currentAccount,
      loading,
      location,
      match,
    } = this.props;
    const { surveyProjectId } = match.params;
    const params = parse(location.search);
    const { sort = {} } = params;
    const { sortBy, sortDir } = sort;
    // header
    const nameHeader = formatMessage(messages.name);
    const createdHeader = formatMessage(messages.created);
    const updatedHeader = formatMessage(messages.updated);

    return (
      <Panel>
        <DataTable
          value={files}
          responsive
          sortField={sortBy}
          sortOrder={toSortOrder(sortDir)}
          onSort={this.onSortChange}
          lazy
          autoLayout
          loading={loading}
        >
          <Column
            field="fileName"
            header={nameHeader}
            body={nameTemplate}
            keyField="id"
            displayField="fileName"
            currentAccount={currentAccount}
            surveyProjectId={surveyProjectId}
            sortable
          />
          <Column field="status" body={statusTemplate} />
          <Column field="createdOn" header={createdHeader} body={timeFieldTemplate} formatDate={formatDate} sortable />
          <Column field="updatedOn" header={updatedHeader} body={timeFieldTemplate} formatDate={formatDate} sortable />
        </DataTable>
      </Panel>
    );
  }
}

ImportedFileList.propTypes = {
  files: PropTypes.arrayOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
    formatDate: PropTypes.func,
  }).isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withAccount(withRouter(injectIntl(ImportedFileList)));
